import { render } from "./IconCross.vue?vue&type=template&id=007504f8"
import script from "./IconCross.vue?vue&type=script&lang=js"
export * from "./IconCross.vue?vue&type=script&lang=js"
script.render = render

export default script